import { render, staticRenderFns } from "./ShareModalHeader.vue?vue&type=template&id=b8740542&scoped=true&"
import script from "./ShareModalHeader.vue?vue&type=script&lang=js&"
export * from "./ShareModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ShareModalHeader.vue?vue&type=style&index=0&id=b8740542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8740542",
  null
  
)

export default component.exports